
/* styles */
require("!!../../node_modules/.pnpm/extract-text-webpack-plugin@2.1.2_webpack@2.7.0/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-56200035\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/selector?type=styles&index=0!./404.vue")

var Component = require("!../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-56200035\"}!../../node_modules/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/node_modules/vue-loader/lib/selector?type=template&index=0!./404.vue"),
  /* scopeId */
  "data-v-56200035",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/404.vue
// module id = 1109
// module chunks = 1